import appCommonReducer from './app-common/appCommonReducer';
import DevReducers from '../customApp/redux/reducers';

export default {
  appCommonReducer,
  ...DevReducers
};
